import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=704d0448"
import script from "./input-number.vue?vue&type=script&lang=js"
export * from "./input-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports